import React, { useEffect, useState } from 'react';
import { RiCloseLine } from '@remixicon/react';

interface ImagePreviewProps {
  src?: string | null;
  alt?: string;
  className?: string;
  previewClassName?: string;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({
  src,
  alt = 'Preview',
  className = '',
  previewClassName = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  if (!src) return null;

  return (
    <>
      <button type="button" onClick={() => setIsOpen(true)} className="w-full">
        <img
          src={src}
          alt={alt}
          className={`cursor-zoom-in rounded-lg ${className}`.trim()}
        />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#171717]/70 backdrop-blur-sm px-4">
          <button
            type="button"
            aria-label="Close preview"
            onClick={() => setIsOpen(false)}
            className="absolute inset-0 cursor-zoom-out"
          />
          <button
            type="button"
            aria-label="Close preview"
            onClick={() => setIsOpen(false)}
            className="absolute top-4 right-4 z-20 size-8 inline-flex items-center justify-center rounded-md bg-white/10 text-static-white/80 hover:text-static-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-static-white/60 transition-colors"
          >
            <RiCloseLine className="size-5" aria-hidden />
          </button>
          <div className="relative z-10 max-h-[85vh] max-w-[90vw]">
            <img
              src={src}
              alt={alt}
              className={`max-h-[85vh] max-w-[90vw] rounded-xl object-contain shadow-custom-shadows-large ${
                previewClassName || ''
              }`.trim()}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImagePreview;
